<script setup lang="ts">
  withDefaults(
    defineProps<{
      modelValue: string
      type: string
      placeholder?: string
    }>(),
    {
      type: 'text',
      placeholder: ''
    }
  )

  const emit = defineEmits(['update:modelValue'])
  function onInput(event: Event) {
    const target = event.target as HTMLInputElement
    emit('update:modelValue', target.value)
  }
</script>
<template>
  <input
    :value="modelValue"
    :type="type"
    :placeholder="placeholder"
    class="w-full rounded-md border border-border px-4 py-3 text-body-1"
    @input="onInput"
  />
</template>
